import React from "react";
import { useSelector } from "react-redux";

import SvgComponent from "../SvgComponent/SvgComponent";

import {
  _Table as Table,
  _TableRow as TableRow,
  _SeasonName as SeasonName,
  _Headline as Headline,
  _TableData as TableData,
  _TableHeader as TableHeader,
} from "./style";

export const SeasonCompare = () => {
  const init = useSelector((state) => state.init);
  const { alias } = init;

  const seasons = [
    {
      name: alias.bfcSummer,
      value: "OPTIMAL",
      info: alias.bfcSeasonSummerInfo,
      iconName: "summer",
      period: alias.bfcSummerPeriod,
      shortDescription: alias.bfcSummerShortDescription,
      hardenedGlass: alias.bfcSummerHardenedGlass,
      uValueGlass: alias.bfcSummerUValueGlass,
      roof: alias.bfcSummerDefaultRoof,
      layers: alias.bfcSummerLayers,
      uValueRoof: alias.bfcSummerUValueRoof,
    },
    {
      name: alias.bfcSpringFall,
      value: "ISOLENT",
      info: alias.bfcSeasonSpringFallInfo,
      iconName: "fall",
      period: alias.bfcSpringFallPeriod,
      shortDescription: alias.bfcSpringFallShortDescription,
      hardenedGlass: alias.bfcSpringFallHardenedGlass,
      uValueGlass: alias.bfcSpringFallUValueGlass,
      roof: alias.bfcSpringFallDefaultRoof,
      layers: alias.bfcSpringFallLayers,
      uValueRoof: alias.bfcSpringFallUValueRoof,
    },
    {
      name: alias.bfcWinter,
      value: "ISOMAX",
      info: alias.bfcSeasonWinterInfo,
      iconName: "winter",
      period: alias.bfcWinterPeriod,
      shortDescription: alias.bfcWinterShortDescription,
      hardenedGlass: alias.bfcWinterHardenedGlass,
      uValueGlass: alias.bfcWinterUValueGlass,
      roof: alias.bfcWinterDefaultRoof,
      layers: alias.bfcWinterLayers,
      uValueRoof: alias.bfcWinterUValueRoof,
    },
  ];

  return (
    <Table>
      <thead>
        <tr>
          {/* Säsong*/}
          <Headline>&nbsp;</Headline>
          {seasons.map((season) => (
            <TableHeader key={season.value}>
              <SvgComponent name={season.iconName} />
              <SeasonName>{season.name}</SeasonName>
            </TableHeader>
          ))}
        </tr>
      </thead>
      <tbody>
        {/* Lämplig period */}
        <TableRow type="period">
          <Headline>{alias.bfcSeasonSuitablePeriod}</Headline>
          {seasons.map((season) => (
            <TableData key={season.value}>{season.period}</TableData>
          ))}
        </TableRow>
        {/* Beskrivning */}
        <TableRow type="period">
          <TableData></TableData>
          {seasons.map((season) => (
            <TableData key={season.value}>{season.shortDescription}</TableData>
          ))}
        </TableRow>
        {/* Uterumsparti */}
        <TableRow type="parti">
          <Headline>{alias.bfcSeasonConservatory}</Headline>
          {seasons.map((season) => (
            <TableData key={season.value}>{season.value}</TableData>
          ))}
        </TableRow>
        {/* Härdat glas */}
        <TableRow type="parti">
          <Headline>{alias.bfcSeasonHardenedGlass}</Headline>
          {seasons.map((season) => (
            <TableData key={season.value}>{season.hardenedGlass}</TableData>
          ))}
        </TableRow>
        {/* U-värde glas */}
        <TableRow type="parti">
          <Headline>{alias.bfcSeasonUValueGlass}</Headline>
          {seasons.map((season) => (
            <TableData key={season.value}>{season.uValueGlass}</TableData>
          ))}
        </TableRow>
        {/* Tak */}
        <TableRow type="roof">
          <Headline>{alias.bfcSeasonRoof}</Headline>
          {seasons.map((season) => (
            <TableData key={season.value}>{season.roof}</TableData>
          ))}
        </TableRow>
        {/* Antal skikt */}
        <TableRow type="roof">
          <Headline>{alias.bfcSeasonLayers}</Headline>
          {seasons.map((season) => (
            <TableData key={season.value}>{season.layers}</TableData>
          ))}
        </TableRow>
        {/* U-värde tak*/}
        <TableRow type="roof">
          <Headline>{alias.bfcSeasonUValueRoof}</Headline>
          {seasons.map((season) => (
            <TableData key={season.value}>{season.uValueRoof}</TableData>
          ))}
        </TableRow>
      </tbody>
    </Table>
  );
};

export default SeasonCompare;
